import DspExpired from './DspExpired';

export default DspExpired;
